module.exports = __webpack_public_path__ + "img/bonus_pc_id.bb3721c2.png";